export default {
  language: {
    'zh-cn': 'Китайский (упрощённый)',
    'en-us': 'Английский',
    'zh-tw': 'Китайский (традиционный)',
    'ru-ee': 'Восточная Европа',
  },
  common: {
    updateInProgress: 'Выполняется обновление… Пожалуйста, подождите.',
    notCurrentDataCenter: 'Выберите базу данных',
    disconnect: 'Разорвать соединение',
    addFail: 'Не добавлено.',
    addSuccess: 'Добавлено.',
    modifyFail: 'Не изменено.',
    modifySuccess: 'Изменено.',
    deleteProjectConfirm: 'Удалить комбинированный проект?',
    deleteProject: 'Удалить комбинированный проект',
    account: 'Аккаунт',
    accountSetting: 'Настройки аккаунта',
    activeMail: 'Письмо с подтверждением',
    activeResult: 'Статус активации',
    alarm: 'Оповещение',
    alarmLevel1: 'Срочно',
    alarmLevel2: 'Обычно',
    alarmLevel3: 'Важно',
    and: 'И',
    appDownload: 'Страница загрузки мобильного приложения',
    australia: 'Австралия',
    backToLogin: 'Вернуться на страницу входа',
    basic: 'Основные',
    cancel: 'Отменить',
    changePasswordSuccessfully: 'Пароль изменён. Войдите заново',
    changeProfileSuccessfully: 'Профиль сохранён',
    china: 'Китай',
    close: 'Закрыть',
    colorScheme: 'Цветовая тема',
    confirm: 'Подтвердить',
    confirm2: 'Подтвердить',
    confirmDiff: 'Пароли не совпадают',
    confirmPassword: 'Подтверждение пароля',
    confirmSettings: 'Подтвердить настройки',
    create: 'Создать',
    currentPassword: 'Текущий пароль',
    dark: 'Тёмная тема',
    darkMode: 'Ночной режим',
    dataCenter: 'База данных',
    dataCenterPickerMemo1: 'Данные будут храниться в выбранной базе данных. Изменить выбор позже нельзя',
    delete: 'Удалить',
    deleteTemplate: 'Удалить шаблон',
    deleteTemplateConfirm: 'Удалить шаблон?',
    device: 'Устройство',
    edit: 'Редактировать',
    europe: 'Европа',
    fail: 'Не удалось',
    getUserInfoFaild: 'Не удалось загрузить данные. Войдите заново',
    goLogin: 'Уже есть аккаунт? Войти?',
    groupPickerMemo1: 'Переместите в любую созданную группу',
    groupPickerMemo2: 'Выберите группу',
    asia: 'Азия',
    len: 'Длина {0} должна быть не менее {1} символов',
    light: 'Светлый',
    lightMode: 'Дневной режим',
    loginSuccessfully: 'Вход выполнен',
    logout: 'Выйти из аккаунта',
    logoutSuccessfully: 'Выход выполнен',
    mail: 'Электронная почта',
    mailFormatError: 'Неверный формат email',
    mailResultMemo1: 'Спасибо за регистрацию. Письмо с подтверждением отправлено навашу электронную почту.',
    mailResultMemo2: 'Перейдите по ссылке в письме, чтобы активировать аккаунт в течение 48 часов.',
    mailResultMemo3: 'Не пришёл код подтверждения?',
    mailResultMemo4: 'Проверьте папки «Спам» и «Реклама»',
    mailResultMemo5: 'Нажмите «Отправить снова»',
    max: 'Введите не более {0} символов',
    menuScheme: 'Цвет меню',
    min: 'Введите не менее {0} символов',
    minMaxLimit: 'Введите {0}–{1} символов',
    moveTo: 'Переместить в...',
    newPassowrd: 'Новый пароль',
    newPwdDiff: 'Пароли не совпадают',
    newPwdSame: 'Новый пароль не может совпадать с текущим',
    no: 'Нет',
    noData: 'Данные отсутствуют',
    offline: 'Офлайн',
    online: 'Онлайн',
    operation: 'Операция',
    operationSuccessfully: 'Операция выполнена',
    pageTotal: 'Всего {0} элементов',
    pageTotal2: 'Всего {0} устройств',
    password: 'Пароль',
    passwordFormatError: '8–16 символов, минимум два из типов: цифры, буквы или символы',
    passwordSetting: 'Настройки пароля',
    permission: 'Права доступа',
    phone: 'Мобильный номер',
    phoneAndMailFormatError: 'Неверный формат телефона или email',
    phoneFormatError: 'Неверный формат телефона',
    pi: 'Введите {0}',
    ps: 'Выберите {0}',
    query: 'Поиск',
    read: 'Чтение',
    readWrite: 'Чтение и запись',
    registerSuccessConfirm: 'Регистрация завершена. Войти?',
    registerSuccessPLogin: 'Аккаунт создан. Войдите, чтобы продолжить',
    reSend: 'Отправить снова',
    resetPassword: 'Сброс пароля',
    roleName: 'Имя роли',
    screen: 'Экран конфигурации',
    settings: 'Настройки',
    submit: 'Отправить',
    successfully: 'Операция выполнена',
    switchToNew: 'Заполните основную информацию о пользователе',
    switchToNewMsg: 'Информация о пользователе заполнена успешно!',
    tag: 'TAG',
    templateLimit: 'Достигнут лимит шаблонов',
    theUnitedStates: 'США',
    tiao: 'Элемент',
    tip: 'Подсказка',
    unbindCurrDevice: 'Подтвердить удаление устройства',
    unbindCurrDeviceMemo: 'Данные устройства будут безвозвратно удалены',
    updateSuccessfully: 'Обновление выполнено',
    userName: 'Имя пользователя',
    valName: 'Название переменной',
    verificationCode: 'Код подтверждения',
    write: 'Запись',
    yes: 'Да',
    cn: 'Китай',
    eu: 'Европа',
    copy: 'Копировать',
    inputPositive: 'Пожалуйста, введите целое положительное число больше 0.',
    importLimit: 'Максимально поддерживается импорт {0} записей.',
    enableLocationPermission: 'Пожалуйста, включите разрешение на определение местоположения браузера',
  },
  login: {
    loginPlatform: 'Войти в облачную платформу DIACloud',
    account: 'Аккаунт',
    password: 'Пароль',
    rememberPassword: 'Запомнить пароль',
    phoneAndMailAndUsername: 'Мобильный номер/электронная почта',
    readAndAgree: 'Я прочитал(а) и принимаю',
    serviceAgreement: 'Условия обслуживания',
    privacyAgreement: 'Политика конфиденциальности',
    registerNow: 'Зарегистрироваться сейчас',
    forgotPassword: 'Забыли пароль?',
    login: 'Вход',
    goLogin: 'Перейти к входу',
    agreeMemo: 'Примите Условия обслуживания и Политику конфиденциальности',
    cookieTips1: 'На этом сайте используются файлы cookie',
    cookieTips2:
      'Мы используем файлы cookie, чтобы улучшить ваш опыт. Уважаем ваш выбор и обеспечиваем безопасность просмотра.',
    reject: 'Отказать',
    accept: 'Принять',
  },
  register: {
    registerWay: 'Способ регистрации',
    register: 'Регистрация',
    phoneRegistration: 'Регистрация по мобильному номеру',
    mailRegistration: 'Регистрация по электронной почте',
    submit: 'Отправить форму регистрации',
    getVarifyCode: 'Oтправлять',
    second: 'Секунда',
    sendToMuch: 'Слишком много попыток отправки',
    contactMemo: 'Этот аккаунт — для уведомлений от устройств. Вход в платформу невозможен.',
  },
  dashboard: {
    operation: 'Операция',
    controlPanel: 'Дашборд',
    dashboard: 'Собирать',
    data: 'Данные',
    alarm: 'Оповещение',
    collectionEmpty: 'Нет избранных устройств',
    goto: 'Перейти',
    download: 'Скачать',
    favoriteDevice: 'Устройство',
    deviceOverview: 'Информация о устройстве',
    hmiScreen: 'Экран HMI',
    deviceState: 'Конфигурация устройства',
    projectState: 'Агрегированная конфигурация',
    IndicatorCard: 'Индикаторная карточка',
    config: 'Экран конфигурации',
    thumbnail: 'Миниатюра',
    viewDcreen: 'Открыть экран конфигурации',
    editScreen: 'Редактировать экран конфигурации',
    configScreen: 'Экран конфигурации',
    hmiBind: 'Информация HMI',
    billingDetail: 'Детали оплаты',
    basicInfo: 'Основная информация',
    configUpdate: 'Информация о конфигурации',
    hmiScreenSN: 'SN экрана HMI',
    hmiGatewaySN: 'SN шлюза HMI',
    deviceName: 'Назваине устройства',
    deviceSN: 'SN устройства',
    deviceModel: 'Модель устройства',
    deviceGroup: 'Группа устройства',
    relateTemplate: 'Привязать к шаблону',
    deviceAddress: 'Адрес устройства',
    remark: 'Заметка',
    configCreate: 'Дата создания',
    configModify: 'Дата изменения',
    maskSuccessfully: 'Добавлено в избранное',
    removeMaskSuccessfully: 'Устройство удалено из избранного',
    editModelMemo: 'Изменения не сохранены. Продолжить без сохранения?',
    notAssociated: 'Не назначено',
    editScreenMsg1: 'Для редактирования используйте DIAWeb Designer',
    editScreenMsg2: 'Если DIAWeb Designer не установлен',
    please: 'Пожалуйста',
    addComponent: 'Добавить компонент',
    selectDevice: 'Выбрать устройство',
    selectProject: 'Выбрать комбинированный проект.',
    noDevicePermission: 'Доступ к этому устройству ограничен.',
    noDeviceConfigPermission: 'Доступ к конфигурации ограничен.',
    noProjectPermission: 'Доступ к комбинированной конфигурации ограничен.',
    IndicatorCardName: 'Название индикаторной карточки',
    dataSource: 'Источник данных',
    icon: 'Иконка',
    deviceTotalNum: 'Общее количество устройств',
    deviceOnline: 'Устройства онлайн',
    deviceOffline: 'Устройства офлайн',
    deviceFault: 'Неисправные устройства',
    componentTitleInfo1: '(Рекомендуется не более 3 штук)',
    compoentEmptyInfo1: 'Выберите компонент и создайте дашборд мониторинга',
  },
  device: {
    unBindDevice: 'Удалить устройство',
    unBindDeviceOk: 'Устройство удалено',
    deviceManage: 'Управление',
    deviceList: 'Список устройств',
    templateList: 'Шаблон для одного устройства',
    deviceGroup: 'Группа устройства',
    tunnel: 'Статус Tunnel',
    groupSameName: 'Название группы уже используется',
    rename: 'Переименовать',
    addGroup: 'Добавить группу',
    addChildGroup: 'Добавить дочернюю группу',
    delete: 'Удалить',
    deleteSucccessful: '{0} удалён(а)',
    groupName: 'Название группы',
    defaultGroup: 'Группа по умолчанию',
    setDefaultGroup: 'Задать как группу по умолчанию',
    templateName: 'Название',
    templateType: 'Тип шаблона',
    localTemplate: 'Локальный шаблон',
    globalTemplate: 'Глобальный шаблон',
    dataCenter: 'База данных',
    hmiModel: 'Модель HMI',
    deviceCount: 'Количество устройств',
    publishTime: 'Дата создания',
    queryNamePh: 'Название',
    queryModelPh: 'Модель HMI',
    addTemplate: 'Добавить шаблон',
    copyTemplate: 'Копировать шаблон',
    deviceName: 'Назваине устройства',
    deviceSN: 'SN устройства',
    description: 'Клиента',
    deviceModel: 'Модель устройства',
    hmiScreenModel: 'Модель HMI',
    cloneTemplate: 'Клонировать шаблон',
    remark: 'Заметка',
    templateInfo: 'Информация о шаблоне',
    hmiScreen: 'HMI-экран',
    fw: 'Прошивка',
    recipe: 'Рецептура',
    versionNumber: 'Номер версии',
    createTime: 'Дата создания',
    configurationState: 'Конфигурация',
    configurationStateCreateTime: 'Дата создания конфигурации',
    configurationStatemodifyTime: 'Дата изменения конфигурации',
    tagName: 'Название тега (TAG)',
    dataType: 'Тип данных',
    addrType: 'Тип адреса',
    address: 'Адрес',
    rwType: 'Тип доступа (чтение/запись)',
    scanTime: 'Время сканирования',
    saveHistroy: 'Сохранение истории',
    devTemProName: 'Название устройства/связанный шаблон/связанный комбинированный проект',
    hmiDongleState: 'Статус шлюза HMI',
    hmiGraph: 'HMI-экран',
    hmiDongleAsync: 'Синхронизация HMI с облаком',
    deviceTag: 'Заметка к устройству',
    tagEmpty1: 'Нет заметок',
    createTag: 'Создать заметку',
    editTag: 'Редактировать заметку',
    deleteTag: 'Удалить заметку',
    addTag: 'Добавить заметку',
    tagNumLimit: 'Максимум 50 заметок',
    checkTagNumLimit: 'Можно выбрать до 10 заметок',
    createAndSearchTag: 'Создать или найти заметку',
    addDevice: 'Добавить устройство',
    syncState1: 'Синхронизировано',
    syncState0: 'Ожидает синхронизации',
    cloudLastVer: 'Последняя версия в облаке',
    hmiThisVer: 'Версия HMI',
    asyncTooltipTitle:
      'м (перейдите на HMI - Системное обновление для синхронизации) Конфигурация между HMI и облаком не синхронизирована.(Для обновления перейдите на устройстве: Системное обновление.)',
    labelOver: 'Длина заметки — от 1 до 50 символов',
    labelSame: 'Имя заметки уже используется',
    labelNumLimit: 'Достигнут лимит заметок (50)',
    deviceChangeGroup: 'Перемещение устройства в группу',
    changeGroupSuccessfully: 'Устройство перемещено в группу',
    addModel: 'Добавить новую модель',
    templateDesign: 'Дизайн конфигурации',
    unbindLabel: 'Удалить заметку',
    unbindLabelConfirm: 'При удалении этой заметки будут удалены все заметки с таким именем. Продолжить?',
    templateDesignConfirm: 'Шаблон {0} используется. Продолжить редактирование?',

    projectlist: 'Комбинированный проект',
    costomName: 'Клиента',
    groupCantRepeat: 'Названия групп не могут повторяться',
    projectName: 'Название',
    deleteProject: 'Удалить',
    deleteProjectConfirm: 'Удалить {0}?',
    addProject: 'Добавить',
    projectTips:
      'Этот агрегированный проект истек. Пожалуйста, активируйте билет на оплату Cloud Application Срок действия комбинированного проекта истёк. Активируйте абонемент Cloud Application',
    projectDetail: 'Основная информация',
    removeDev: 'Удалить устройство',
    removeDevConfirm: 'Удалить устройство {0}?',
    relatDev: 'Связанные устройства',
    viewTag: 'Просмотреть теги (TAG)',
    remove: 'Удалить',
    assignGroupPm: 'Назначьте права доступа к группе устройств',
    project: 'Комбинированный проект',
    assignProjectPm: 'Назначьте права доступа к списку комбинированных проектов',
    usedTemplate: 'Ссылка на шаблон',
    usedProject: 'Ссылка на комбинированный проект',
    devNameTip: 'Название должно начинаться с латинской буквы или китайского иероглифа',
    devNameTip2:
      'Название устройства может содержать только латинские буквы, цифры, символ подчёркивания и, при необходимости, иероглифы (Unicode)',

    noTemplate: 'Шаблон не назначен',
    noConfig: 'Для выбранного шаблона не создан экран конфигурации.',
    noSpace: 'азвание устройства не может содержать пробелы',
    noKeyword: 'Название не должно совпадать с зарезервированными словами и спецсимволами.',
    removeProjectInfo3: 'Привязки в комбинированных проектах не отменены',

    alreadySelectDevice: 'Количество выбранных устройств: {0}',

    deviceoverview: 'Обзор устройств',
    deviceTotal: 'Общее количество устройств',
    monthIncrease: 'По сравнению с предыдущим месяцем',
    monthDecrease: 'По сравнению с предыдущим месяцем',
    deviceOnline: 'Устройства онлайн',
    onlineRate: 'Процент онлайн-устройств',
    deviceOffline: 'Устройства офлайн',
    offlineRate: 'Процент офлайн-устройств',
    deviceRegional: 'Географическое распределение устройств',
    alarmLevel: 'Распределение по уровням оповещений',
    level1: 'Легкое',
    level2: 'Небольшое',
    level3: 'Среднее',
    level4: 'Значительное',
    level5: 'Серьезное',
    faultOverview: 'Обзор неисправностей',
    alarmNum: 'Количество оповещений',
    responsesNum: 'Реакция на оповещение',
    failRate: 'Процент неисправных устройств',
    global: 'Глобально',
    comparedLastMonth: 'По сравнению с предыдущим месяцем',
    lowSDKVersion:
      'Текущая версия HMI устарела. Пожалуйста, обновите программное обеспечение до версии 1.0.0.5 или выше.',
    addDatacenter: 'Создать новую базу данных',
    map: 'Карта',
    location: 'позиция',
  },
  template: {
    defaultValue: 'Значение по умолчанию',
    description: 'Описание',
    templateMemo: 'Описание шаблона',
    bindTemplateTip: 'Подтвердить привязку шаблона',
    templateLockTip1: 'Срок действия шаблона истёк. Активируйте билет Cloud Application и пополните лимит шаблонов.',
    templateLockTip2:
      ' ЗАМЕТКА:  После активации шаблоны восстанавливаются сначала самые новые. Следите за лимитом, чтобы важные шаблоны не были удалены.',
  },
  message: {
    messageCenter: 'уведомлений',
    alarm: 'Оповещение',
    system: 'Системное объявление',
    billingMsg: 'Уведомления об оплате',
    alarmMag: 'История оповещений',

    billingMsgType1: 'Уведомление о приближении срока действия Remote Access',
    billingMsgType2: 'Уведомление о приближении срока действия Cloud Application',
    billingMsgType3: 'Уведомление о приближении срока действия тегов (TAG) устройства',
    billingMsgType4: 'Уведомление о нехватке трафика устройства',
    billingMsgType5: 'Уведомление о нехватке тегов (TAG) в аккаунте',
    billingMsgType6: 'Уведомление о приглашении',
    billingMsgType7: 'Уведомление об отмене приглашения',
    billingMsgType8: 'Уведомление о удалении из команды',
    billingMsgType9: 'Уведомление о передаче прав основного аккаунта',

    readAllTip: 'Все уведомления отмечены как прочитанные',
    total: 'Все',
    unread: 'Непрочитанные',
    msgType: 'Тип уведомления',
    startDate: 'Дату Активации',
    endDate: 'Дату Активации',
    readAll: ' Все уведомления отмечены как прочитанные\n',
    billing: 'Оплата',
    notifications: 'Объявление',
    warnings: 'Оповещение',
    noUnread: 'Уведомлений нет',
    noUnreadToday: 'Непрочитанных уведомлений нет',
    goAllMsg: 'Просмотреть все',
    monthTraffic: 'Расход трафика за текущий месяц',
    open: 'Включено',
    close: 'Выключено',
    continued: 'Продолжить использование',
    closeTraffic: 'Отключить трафик',
    todayNews: ' Уведомления за сегодня ({0})',
    trafficTips1: 'Подтверждаете включение трафика?',
    trafficTips2: 'После включения трафик нельзя отключить до конца месяца. Будьте внимательны.',
    trafficTips3:
      ' Недостаточно трафика? Пополните счёт через «Управление оплатой — Мой аккаунт» и привяжите абонемента к устройству.',
    trafficTips4: 'Использовано 12 ГБ трафика. Продолжить?',
    trafficTips5: ' Отключение действует только в этом месяце. В следующем трафик восстановится автоматически.',
    trafficTips6: ' Чтобы включить трафик снова, перейдите в «Управление устройствами — Список устройств».',
    trafficTips7: 'Трафик за текущий месяц отключен',
    trafficTips8: ' Чтобы возобновить трафик, перейдите в «Список устройств — Детали устройства» и включите его.',
  },

  system: {
    name: 'Название',
    system: 'Системное',
    role: 'Управление ролями',
    user: 'Пользователями',
    apiManage: 'Управление API',
    personCenter: 'Личный кабинет',
    safeZone: 'Безопасная зона',

    operations: 'Оперативное',
    dashboard: 'Собирать',
    controlpanel: 'Дашборд',
    device: 'Управление',
    billing: 'Управление оплатой',
    maintenance: 'Обслуживание',
    message: 'уведомлений',

    devicelist: 'Список устройств',
    templatelist: 'Шаблон для одного устройства',
    devicegroup: 'Группа устройств',
    projectlist: 'Комбинированный проект',
    myAccount: 'Мой аккаунт',
    rechargeRecord: 'История пополнений',
    msgBilling: 'Уведомления об оплате',
    firmware: 'Управление архивами',
    relatProject: 'Комбинированный проект',

    DIACom: 'DIACom',
    DIAComTip: 'Только включённые устройства с доступом для вас отображаются в DIACom.',

    'dashboard-view': 'Доступ',
    'controlpanel-view': 'Доступ',

    'devicelist-view': 'Доступ',
    'devicelist-bind': 'Привязать устройство',
    'devicelist-edit': 'Редактировать',
    'devicelist-delete': 'Удалить',
    'devicelist-hmi': 'Просмотр и управление HMI',
    'devicelist-hmi-check': 'Просмотреть экран HMI',
    'devicelist-alloc': 'распределять',
    'devicelist-config': 'Экран конфигурации',
    'devicelist-alarm': 'Оповещение',
    'devicelist-monitor': 'Данные мониторинга',

    'templatelist-view': 'Доступ',
    'templatelist-add': 'Добавить новый шаблон',
    'templatelist-copy': 'Копировать шаблон',
    'templatelist-edit': 'Добавить/редактировать шаблон',
    'templatelist-delete': 'Удалить',
    'templatelist-data-pm': 'Назначить права доступа',

    'devicegroup-view': 'Доступ',
    'devicegroup-add': 'Добавить новую группу',
    'devicegroup-edit': 'Редактировать',
    'devicegroup-delete': 'Удалить',
    'devicegroup-data-pm': 'Назначить права доступа',

    'projectlist-view': 'Доступ',
    'projectlist-add': 'Добавить',
    'projectlist-edit': 'Редактировать',
    'projectlist-delete': 'Удалить',
    'projectlist-data-pm': 'Назначить права доступа',

    'myAccount-view': 'Доступ',
    'myAccount-ca-charge': 'Пополнение Cloud Application',
    'myAccount-ca-allcoate': 'Назначение тегов (TAG)',
    'myAccount-ra-charge': 'Пополнение Remote Access',
    'myAccount-ra-allcoate': 'Назначение билетов на оплату',

    'rechargeRecord-view': 'Доступ',

    'msgBilling-view': 'Доступ',

    'firmware-view': 'Доступ',
    'firmware-upload': 'Загрузить архив',
    'firmware-auth': 'Авторизовать',
    'firmware-delete': 'Удалить',
    'firmware-dispatch': 'Отправить PLC',

    'user-view': 'Доступ',
    'user-invite': 'Пригласить пользователя',
    'user-edit': 'Сменить роль',
    'user-delete': 'Удалить',
    'user-data-pm': 'Права доступа к данным',

    'role-view': 'Доступ',
    'role-add': 'Добавить новую роль',
    'role-edit': 'Редактировать',
    'role-delete': 'Удалить',

    'apiManage-view': 'Доступ',
    'apiManage-add': 'Создать API Key',
    'apiManage-edit': 'Редактировать',
    'apiManage-delete': 'Удалить',
    'apiManage-download': 'Скачать документ API',
    'apiManage-reset': 'Сбросить Secret',

    'safeZone-view': 'Доступ',
    'safeZone-add': 'Добавить новую безопасную зону',
    'safeZone-edit': 'Редактировать',
    'safeZone-delete': 'Удалить',

    mainAccount: 'Администратор команды',
    subAccount: 'Субаккаунт',
    teamName: 'Название команды',
    team: 'Команда',
    modifyTeamName: 'Чтобы изменить название команды, нажмите на имя пользователя в правом верхнем углу.',
    No: 'Порядковый номер',
    roleName: 'Имя роли',
    cannotDelete: 'Невозможно удалить {0}',
    deleteRoleFirst: 'Перед удалением роли открепите всех пользователей.',
    isDelete: 'Удалить {0}?',
    addsafeZone: 'Добавить новую безопасную зону',
    addRole: 'Добавить новую роль',
    selectPmSettings: 'Пожалуйста, выберите настройки прав доступа',
    enterRoleName: 'Введите имя роли',
    editRole: 'Редактировать роль',
    inviteAcceptTime: 'Время принятия приглашения',
    multipleSelection: 'Допускается несколько вариантов',
    Pmettings: 'Настройка прав доступа',
    menuBar: 'Меню',
    selectAll: 'Выделить все',
    operationPm: 'Права доступа',
    dataPm: 'Права доступа к данным',
    safeZoneInUse: 'Роли используются в этой зоне. Удаление невозможно.',
    inputAlphanumeric: 'Разрешены: латинские буквы и цифры',
    inputAlphaNumericOnly: 'Разрешены только латинские буквы и цифры',
    editsafeZone: 'Редактировать безопасную зону',
    removeFromTeam: 'Удалить {0} из команды?',
    cancelPendingInvitations: 'Не принятые приглашения будут отменены после удаления.',
    accountUsername: 'Логин (имя пользователя)',
    inviteUser: 'Пригласить пользователя',
    emailAccount: 'Адрес электронной почты',
    registerAccount: 'Аккаунт не зарегистрирован. Завершите регистрацию.',
    notCurrentDataCenterAccount: 'Аккаунт не принадлежит текущему дата-центру',
    joinedOtherTeams: 'Этот аккаунт уже состоит в другой команде',
    inCurrentTeam: 'Этот аккаунт уже находится в текущей команде',
    notInCurrentTeam: 'Этот аккаунт не входит в текущую команду',
    roleChange: 'Смена роли',
    announcement: 'Объявление',
    startClearData: 'Начать очистку данных',
    acceptAndReLogin: 'Подтвердить и перезайти',
    rejectInvite: 'Отклонить приглашение',
    inviteNotification: 'Уведомление о приглашении',
    inviteJoinTeam1: '{0} приглашает вас присоединиться к команде {1}',
    dataOnAccount:
      'Чтобы присоединиться к команде без переноса таких личных данных как устройства, шаблоны, комбинированные проекты, создайте новый аккаунт.',
    unbindDevices: 'Перед присоединением к команде удалите устройства, шаблоны и проекты. Данные восстановить нельзя.',
    clearDataNotice:
      'Абонемент и история пополнений сохранятся. При переносе в командный аккаунт Личный абонемент не переносится и история пополнений будет недоступна',
    clearDataEffect: 'После очистки данных назначенные теги (TAG) и трафик не будут затронуты',
    successJoinTeam: 'После присоединения права будут назначены администратором команды.',
    reInviteIfRejected:
      'Чтобы присоединиться позже, попросите отправить приглашение снова после отклонения приглашения.',
    unbindDevice: 'Отменить привязку устройства',
    confirmDeleteDevice1: 'Подтвердить удаление устройства {0}?',
    confirmDeleteDevice2: 'Удалить устройство {0}?',
    deleteDeviceWarning: 'После удаления устройства его данные мониторинга будут безвозвратно удалены.',
    invitePage: 'Страница приглашения',
    nextStep: 'Далее',
    inviteCancelled1: 'Это приглашение отменено',
    youRejectedInvite: 'Вы отклонили это приглашение',
    reInviteIfNeeded: 'Чтобы присоединиться к команде, попросите отправителя повторить приглашение',
    alreadyInTeam: 'Вы уже состоите в этой команде',
    inviteExpired: 'Это приглашение недействительно',
    reminder: 'Напоминание',
    viewInvites: 'Проверить сейчас',
    pendingInvites: 'У вас есть неподтверждённые приглашения. Проверьте их в Центре уведомлений.',
    inviteJoinTeam2: '{0} приглашает вас в команду {1}. Принять приглашение?',
    inviteCancelled2: '{0} отменило приглашение присоединиться к команде {1}',
    removedFromTeam: 'Вы были удалены из команды',
    inviteBecomeMainAccount: '{0} предлагает вам стать администратором команды {1}. Принять?',
    editTeamName: 'Редактировать название команды',
    teamNamePlaceholder: 'Название команды',
    inviteSent: 'Приглашение отправлено. Ожидание подтверждения.',
    assignRoleListPm: 'Пожалуйста, назначьте права доступа к списку ролей',
    assignPm: 'Назначить права доступа',
    contactAdminForPm: 'Для получения прав доступа свяжитесь с администратором',
    close: 'Закрыть',
    pendingInvitesAgain: 'У вас есть неподтверждённые приглашения. Проверьте их в Центре уведомлений.',
    userAccount: 'Аккаунт',
    systemAdministrator: 'Системный администратор',
    allPm: 'Все',
    platformAllPm: 'Обладает всеми правами доступа к платформе',
    setRolePm: 'Назначьте права доступа для роли.',
    enterRoleNamePlaceholder: 'Введите имя роли',
    maxTenCharacters: 'Максимум 10 символов',
    assignTemplateListPm: 'Пожалуйста, назначьте права доступа к списку шаблонов',
    addDataPm: 'Добавить права доступа к данным',
    multipleSelection2: 'Допускается несколько вариантов',
    removePm: 'Отозвать права доступа',
    continueSending: 'Продолжить отправку',
    sendBillingMessages: 'Название команды не задано. Продолжить отправку приглашений?',
    sameDataCenterAccounts:
      'Можно приглашать только аккаунты из одного дата-центра Приглашать можно только аккаунты из одной базы данных.',
    access: 'Доступ',
    cloudApplicationTopUp: 'Пополнение Cloud Application',
    remoteAccessTopUp: 'Пополнение Remote Access',
    noGroups: 'Группы отсутствуют',
    contactAdminForPm2: 'Для получения прав доступа свяжитесь с системным администратором',
    uniqueTeamGroups: 'Группы в команде должны быть уникальными.',
    loginWebToAcceptInvite: 'Войдите в веб-интерфейс, чтобы принять приглашение',
  },
  billing: {
    billingManage: 'Оплата',
    myAccount: 'Мой аккаунт',
    billingOverview: 'История оплат',
    rechargeRecords: 'История пополнений',
    cardType: 'Тип абонемента',
    cardNumber: 'Номер карты',
    cardName: 'Название абонемента',
    cloudAppCard: 'Cloud Application',
    remoteAccessCard: 'Remote Access',
    activeOp1: 'Введите последние 8 цифр номера карты',
    activeOp2: 'Снимите защитную полосу и введите код',
    activeOp3: 'Переверните карту — код под защитной полосой',
    activating: 'Действует',
    Outdated: 'Истек срок действия',
    noActivated: 'Не активировано',
    activeDate: 'Дата активации',
    selectActiveDate: 'Дату Активации',
    status: 'Статус',
    validityDate: 'Срок действия',
    TagVal: 'Срок действия тега (TAG)',
    opAccount: 'Аккаунт оператора',
    deviceLevel: 'Текущий уровень устройства',
    deviceNowTag: 'Текущие теги (TAG) устройства: использовано/всего',
    allocateDevice: 'Привязать устройство',
    allocateDate: 'Продолжительность привязки',
    selectAllocateDate: 'Продолжительность привязки',
    allocateLevel: 'Назначенный уровень',
    allocateTagNum: 'Количество привязанных тегов(TAG)',
    allocateTagStatus: 'Состояние привязки тегов (TAG)',
    allocateTagVal: 'Срок действия привязки тега (TAG)',
    allocateCard: 'Привязать абонемент',
    sTagNum: 'Оставшиеся теги (TAG)',
    sTemplateNum: 'Оставшиеся шаблоны',
    platformGifts: 'Бонус от платформы',
    rechargeNow: 'Пополнить счет сейчас',
    total: 'Общий объём',
    unit: 'Единица',
    unit2: 'Карточка',
    used: 'Использовано',
    left: 'Остаток',
    tagAllocate: 'Привязка тегов(TAG)',
    cardAllocate: 'Оплатить по абонементу',
    allocateTips1: 'Привяжите {0} к устройству',
    allocateTips2: 'Следите за сроком {0} — неиспользованные доступы сгорят',
    allocateTips3: '{0}, привязанные к устройству, доступны только на нём до окончания срока.',
    viewAll: 'Просмотреть детали',
    template: 'Шаблон',
    cardUseAla: 'Анализ Использования',
    num: 'Количество',
    notSet: 'Отложить выбор уровня',
    keepNowLevel: 'Сохранить текущий уровень устройства',
    allocateTips: 'Количество тегов (TAG): {0} шт. / Частота сбора: {1} мин.',
    level: 'Уровень',
    CollFrequency: 'Частота сбора данных',
    Minutes: 'Минута',
    tagNumber: 'Количество тегов (TAG)',
    month: 'Месяц',
    year: 'Год',
    deviceDetail: 'Детали устройства',
    returnTag: 'Вернуться к привязке тегов (TAG)',
    returnDetail: 'Вернуться к деталям тега (TAG)',
    deviceUnbind: 'Устройство отвязано от данного аккаунта',
    notThisAccount: 'Внимание: пополнение с другого аккаунта',
    levelDesc: 'Описание уровня',
    allocateTips4: 'Тегам, выданным платформой, доступен только уровень {0}',
    allocateTips5: 'Правила активации тегов (TAG) (Частота опроса тегов зависит от назначенного уровеня)',
    allocateTips6: 'Понижение назначенного уровеняне поддерживается',
    allocateTips7: 'При смене аккаунта неиспользованные {0} остаются на устройстве',
    allocateTips8: 'Неиспользованный баланс остаётся на устройстве при смене аккаунта',
    optionalRange: 'Допустимый диапазон',
    unallocated: 'Ожидает привязку',
    nowAllocateTagNum: 'Текущее количество доступных для привязки тегов (TAG)',
    avaleBalance: 'Доступный баланс',
    CurrAllocate: 'Текущая привязка',
    allCardNum: 'Общее количество',
    activedCardNum: 'Действует',
    deactivedCardNum: 'Истек срок действия',
    allocateSuccess: 'Привязка завершена',
    tagStatus: 'Статус тега (TAG)',
    allocatedTagStatus: 'Состояние привязки тегов (TAG)',
    traffic: 'Трафик',
    trafficCard: 'Карта трафика',
    trafficTips: 'Оповещение об использовании трафика',
    billcardPackage: 'Пакет абонемента',
    billcardActive: 'Активация абонементов',
    dataStorage: 'Хранение данных',
    validityPeriod: 'Срок действия',
    dataCollFrequency: 'Частота сбора данных',
    templateNum: 'Количество шаблонов',
    pleaseInput: 'Введите',
    pleaseSelect: 'Выберите',
    numTip: 'Введите номер карты',
    passwordTip: 'Введите код доступа',
    InputEnAndNum8: 'Введите 8 символов (латинские буквы и цифры)',
    InputEnAndNum16: 'Введите 8 символов (латинские буквы и цифры)',
    activedTips: 'ПОДСКАЗКА',
    activedTips1: 'Абонемент активируется сразу после оплаты и действует 1 год.',
    activedTips2: 'Используйте пакет до конца срока действия',
    cardNum: 'Номер карты',
    cardPassword: 'Код доступа',
    InputPassword: 'Введите 8-значный код доступа',
    InputNum: 'Введите последние 8 цифр номера карты',
    successTip: 'Абонемент активирован',
    cardValidityDate: 'Срок действия абонемента',
    successTip2: 'Используйте абонемент в течение срока действия',
    failTip: 'Не удалось активировать абонемент',
    failReasonTip: 'Причина неудачной активации',
    next: 'Далее',
    activeNow: 'Активировать сейчас',
    gotIt: 'Окей',
    actived: 'Действует',
    deActived: 'Истек срок действия',
    tagMessage: 'Недостаточно тегов. Пополните с помощью абонемента Cloud Application',
    action: 'Пополнить баланс',
    know: 'Окей',
    description1: 'После пополнения настройки сохранятся автоматически',
    cloudApplication: 'Cloud Application',
    remoteAccess: 'Remote Access',

    vncTips1: 'VNC активен. Трафик расходуется по факту использования. Используйте экономно!',
    disabledTemplates: '{0} тегов шаблона недоступны',
    tagInfo: 'Информация о теге (TAG)',
    requirements1: 'Проверьте, что все теги шаблона готовы к использованию',
    requirements2: 'Количество тегов устройства должно быть не меньше, чем в шаблоне',
    deviceTagCount: 'Количество доступных тегов (TAG) устройства',
    templateTagCount: 'Количество тегов (TAG) шаблона',
    vncTips2: 'При подключении к HMI трафик будет списываться по факту использования. Продолжить?',
    vncEnd: 'Использование VNC завершено',
    timeLimitReached: 'Истекло максимальное время VNC-сессии. Подключение закрыто.',
    vncTimeSetting: 'Настройка времени сессии HMI',
    instruction: 'По истечении времени VNC-сессия будет закрыта автоматически',
    tagAction: 'Установить максимальное время',
    trafficTips1: 'Недостаточно трафика. Пополните баланс через Remote Access.',
    trafficTips2: 'Трафик исчерпан. Устройство не может передавать данные.',
    trafficTips3:
      'Статистику расхода трафика смотрите в разделе “Управление оплатой — Счёт” на облачной платформе DIACloud',
    trafficTips4: 'Устройство отключено от аккаунта',
    trafficTips5: 'Подключение VNC прервано: недостаточно трафика',

    selectCardType: 'Выберите спецификацию карты',
    trafficTips6: 'Неиспользованный Remote Access можно привязать к устройству в разделе {0}',
    myCount: 'Мой аккаунт — История моек по абонементу',
    activate: 'Активация',
    trafficTips7:
      'Тарифный план можно использовать только после привязки к устройств. Используйте тариф до окончания срока — иначе он сгорит.',
    notAllocate: 'Отложить привязку',
    billingCard: 'Абонемент',
    trafficTips8: 'После привязки изменить устройство нельзя',
    trafficTips9: 'Внимание: действие нельзя отменить',
    trafficTips10: 'Система автоматически тратит трафик с ближайшим сроком действия',
    confirmAllocationTips: 'Подтвердите использование пакета на “{0}”?',
    confirmAllocation: 'Подтвердить привязку',
    trafficPeriod: 'Срок действия трафика',
    billingCardTraffic: 'Баланс абонемента',
    trafficTotal: 'Общий трафик',
    trafficUsed: 'Использованный трафик',
    trafficLeft: 'Оставшийся трафик',
    trafficStatus: 'Статус оставшегося трафика',
    trafficLeftCard: 'Оставшийся трафик на карте',
    trafficLeftDevice: 'Остаток трафика на устройстве',
    billingCardUsage: 'Анализ Использования',
    trafficStatistics: 'Статистика по оставшемуся трафика',
    trafficsLeftValid: 'Оставшийся трафик',
    trafficsLeftTotal: 'Общий остаток трафика',
    selectDateActive: 'Дату Активации',
    selectDateUsedMin: 'Дату Активации',
    selectDateUsedMax: 'Дату Активации',
    DateofUse: 'Дата списания',
    trafficUsed2: 'Текущее потребление',
    trafficUsage: 'Детали расхода трафика',

    freeDongle: 'Бонус за подключение Dongle',
    freeHMI: 'Бонус за подключение HMI',
    annualCard: 'Годовая карта',
    lifetimeCard: 'Пожизненная карта',
  },

  alarm: {
    devOrAlarmName: 'Название устройства/название оповещения',
    alarmName: 'Имя оповещения',
    alarmGroup: 'Группа оповещений',
    alarmLevel: 'Уровень оповещения',
    alarmType: 'Тип оповещения',
    tagName: 'Название тега (TAG)',
    alarmValue: 'Значение оповещения',
    alarmTarget: 'Целевое значение',
    alarmRule: 'Значение отклонения',
    alarmContent: 'Содержание оповещения',

    alarmGroupMange: 'Управление группами оповещений',

    alarmCondition: 'Условие оповещения',
    alarmState: 'Статус оповещения',
    alarmTime: 'Время оповещения',
    responseTime: 'Время реакции на оповещение',
    recoveryTime: 'Время восстановления',
    resUser: 'Ответственный оператор',

    minor: 'Незначительное',
    mild: 'Лёгкое',
    moderate: 'Среднее',
    severe: 'Сильное',
    critical: 'Серьезное',
    HighHigh: 'Достаточно высокое',
    High: 'Высокое',
    Low: 'Критическое',
    LowLow: 'Значительное',
    LargeDeviation: 'Крупное отклонение',
    SmallDeviation: 'Малое отклонение',
    off: 'Выключено',
    on: 'Включено',

    alarm: 'Оповещение',
    response: 'Реакция на оповещение',
    recovery: 'Восстановление',

    add: 'Добавить',
    repeat: 'Название оповещения должно быть уникальным',
    onOffTip: 'При формировании оповещения о состоянии для переключателя используется логическое значение: 0 или 1.',
    onTip: 'Для состояния “Включено” допустимо только значение 1',
    OffTip: 'Для состояния “Выключено” допустимо только значение 0',
    deviation: 'Оповещение о превышении лимита',
    limit: 'Оповещение об отклонении',
    onOff: 'Оповещение о состоянии',

    selectTag: 'Выбрать тег (TAG)',
    errTips1: '{0} не заполнено',
    errTips2: '{0} не найдено',
    errTips3: 'Для оповещений типа {0} нельзя использовать строковые и логические теги',
    errTips4: 'Для оповещений типа {0} разрешены только логические теги (Bool)',
    addAlarm: 'Добавить новое оповещение',
    editAlarm: 'Изменить оповещение',
    when: 'Когда',
    state: 'Статус',
    errRes: 'Причина неудачи',
    import: 'Импорт',
    export: 'Экспорт',
    importErr: 'Импорт данных не удался',
    errMsg1: 'Скачайте отчет об ошибках, исправьте данные в соответствии с подсказками и загрузите снова',
    downloadErr: 'Скачать отчет об ошибках',
    clickUpload: 'Нажмите для загрузки',
    importRule: 'Требования к импорту',
    importMsg: 'Пожалуйста, заполните данные в соответствии с форматом шаблона',
    importMsg2: 'Перетащите файл сюда или',
    importMsg3: 'Поддерживаются форматы: .xlsx или .xls',
    importMsg4: 'Максимальное количество записей для импорта: 300',
    importMsg5: 'Можно экспортировать до 10 000 записей',
    importMsg6: 'При совпадении названий правило оповещения будет обновлено',
    downloadTem: 'Скачать шаблон',
    importComplate: 'Импорт данных завершен успешно',
    fileName: 'Имя файла',
    dataNum: 'Общий объём данных',
    importOK: 'Импорт выполнен успешно',
    importTime: 'Время импорта',
    selectToRes: 'Подтвердите оповещение',
    uploadAgain: 'Перезагрузить',
    goList: 'Вернуться к списку',
    selectAlarmType: 'Сначала выберите тип оповещения',
    typeErr: 'Неверный формат файла. Загрузите .xlsx или .xls',
    goAlarmMsg: 'Просмотреть и подтвердить оповещения',
    fileTypeErr: 'Неверный формат  импортируемого файла',
    fullText: 'Полный текст',
    notMatch1: 'Введенное значение оповещения не совпадает с типом тега (TAG)',
    notMatch2: 'Неверный формат значения отклонения',
    notMatch3: 'Некорректный формат целевого значения',
    tagInvalid: 'Идентификатор тега (TAG) не найден',
  },
  monitor: {
    piCharacters: 'Введите 1–255 символов',
    dataMonitor: 'Мониторинг данных',
    startCollect: 'Запустить сбор данных',
    stopCollect: 'Остановить сбор данных',
    collectionConfig: 'Настроить сбор данных',
    addMonitor: 'Добавить мониторинг',
    copyMonitor: 'Скопировать настройки мониторинга',
    batchOperations: 'Групповые операции',
    batchAdd: 'Групповое добавление',
    batchDelete: 'Групповое удаление',
    moreOperation: 'Дополнительные операции',
    monitorName: 'Название мониторинга',
    value: 'Значение',
    match: 'Совпадает',
    mismatch: 'Не совпадает',
    configStatus: 'Статус конфигурации',
    description: 'Описание',
    address: 'Адрес',
    collectFrequence: 'Частота сбора данных',
    opertaion: 'Операция',
    collectConfirmMsg:
      'Устройство начнёт сбор данных, и трафик будет расходоваться в зависимости от активности. Рекомендуем учитывать это при использовании.',
    collectQuitMsg: 'Сбор данных автоматически останавливается при выходе из приложения',
    saverMode: 'Настроить Эко-режим',
    saverMsg: 'Применимо ко всем тегам(TAG)',
    type: 'Тип данных',
    selectType: 'Сначала выберите тип данных',
    nameValidMsg: 'Введите название мониторинга',
    typeValidMsg: 'Выберите тип данных',
    sizeValidMsg: 'Введите максимальную длину символов',
    decimaValidMsg: 'Введите количество знаков после запятой',
    stepValidMsg: 'Введите приращение',
    batchNumValidMsg: 'Введите количество приращений',
    selectAddressPs: 'Выберите адрес',
    link: 'Тип подключения',
    plcManufacturer: 'Производитель PLC',
    plcName: 'Название PLC',
    model: 'Тип',
    station: 'Номер станции',
    defaultValue: 'Значение по умолчанию',
    componentType: 'Тип компонента',
    addressValue: 'Адрес (число)',
    linkValidMsg: 'Сначала выберите тип подключения',
    plcFacValidMsg: 'Производитель PLC не выбран',
    plcNameValidMsg: 'Название PLC не выбрано',
    stationValidMsg: 'Введите номер станции',
    componentValidMsg: 'Выберите тип компонента',
    addressValidMsg: 'Введите адрес',
    decimal: 'Знаков после запятой',
    size: 'Максимум символов',
    step: 'Приращение',
    batchNum: 'Количество (групповая операция)',
    uploadLimitMsg: 'Поддерживается импорт до {0} мониторингов за операцию',
    monitorDeleteConfirm: 'Подтвердить удаление мониторинга',
    monitorDeleteSelectedConfirm: 'Подтвердить удаление выбранных мониторингов',
    uploadNameRule: 'Если мониторинг с таким названием уже есть — он будет заменён',
    monitorNameNoRepeat: 'Дублирование названий мониторинга запрещено',
    internalMemory: 'Внутренний регистр',
    component: 'Компонент',
    constant: 'Постоянная величина',
    importMonitor: 'Импортировать мониторинг',
    collectFail: 'Сбой отправки параметров сбора данных.',
    deleteMismatch: 'Удалить несоответствующие мониторинги',
    keepCollect: 'Продолжить сбор данных',
    configStatusInfo: 'Сопоставить настройки мониторинга с устройством',
    editMonitor: 'Редактировать мониторинг',
    selectAddress: 'Выбрать адрес',
    addSuccessMsg1: 'Мониторинг вида «{0}» успешно добавлен.',
    configSaveSuccessMsg: 'Конфигурация сохранена успешно',
    configSaveFailMsg: 'Сохранение конфигурации не удалось',
    monitorEmptyInfo1: 'Настройте панель мониторинга',
    sizeValidMsg2: 'Поддерживаются целые числа, большие или равные 0.',
    sizeValidMsg3: 'Длина входных данных должна быть целым неотрицательным числом.',
    sizeValidMsg4: 'Поддерживаются целые числа, большие или равные 1.',
    decimaValidMsg2: 'Поддерживаются целые числа от 0 до 6 включительно.',
    decimaValidMsg3: 'Поддерживаются целые числа от 0 до 14 включительно.',
    batchNumValidMsg2: 'Поддерживаются целые числа от 2 до {0}.',
    nameValidMsg2: 'Максимум 255 символов.',
    typeValidMsg2: 'Несоответствие типа данных. Введите значение, совместимое с этим полем.',
    stationValidMsg2: 'Номер станции — целое число от 0 и выше',
    plsSelectMonitor: 'Выберите точку мониторинга для удаления.',
    collectErrorMsg1: 'Отправка параметров сбора прервана: обнаружены некорректные конфигурации мониторинга.',
    // excel模板字段
    template: {
      name: 'Название',
      type: 'Тип данных',
      decimal: 'Знаков после запятой',
      size: 'Максимум символов',
      linkType: 'Тип подключения',
      station: 'Номер станции',
      componentType: 'Тип компонента',
      addressNum: 'Адрес (число)',
      desc: 'Описание',
    },
    gathertip: 'Сбор данных остановлен. Перезапустите, чтобы продолжить.',
    didEmpty: 'Сначала подключите устройство к сети',
  },
  history: {
    time: 'Время',
    historyData: 'Исторические данные',
    lastest: 'Последние операции',
    minute: 'Минута',
    hour: 'Час',
    day: 'День',
    week: 'Неделя',
    month: 'Месяц',
    year: 'Год',
    ascend: 'По возрастанию',
    descend: 'По убыванию',
    selectTAG: 'Выбрать тег (TAG)',
    enableTAG: 'Включить тег',
    timeDistance: 'Период времени',
    timeInterval: 'Интервал времени',
    row: 'Строка',
    selectTagLimit: 'Максимум {0} элементов можно добавить',
    define: 'Пользовательский',
    hasChoose: 'Выбрано',
    selectTagHint: 'Выберите тег (TAG), чтобы просмотреть исторические данные.',
    goSelectTag: 'Перейти к выбору тегов (TAG)',
    step1: 'i. Сначала подключите устройство к сети',
    step2: 'ii. Привяжите устройство к шаблону',
    step3: 'iii. Шаблон устройства должен содержать числовые теги (TAG) , доступные для архивации',
  },
  ERR_FR_TOO_MANY_REDIRECTS: 'Слишком много перенаправлений',
  ERR_BAD_OPTION_VALUE: 'Неверное значение параметра',
  ERR_BAD_OPTION: 'Неверный параметр',
  ERR_NETWORK: 'Ошибка подключения',
  ERR_DEPRECATED: 'Устаревшая функция',
  ERR_BAD_RESPONSE: 'Ошибка ответа',
  ERR_BAD_REQUEST: 'Ошибка запроса',
  ERR_NOT_SUPPORT: 'Не поддерживается',
  ERR_INVALID_URL: 'Неверный URL',
  ERR_CANCELED: 'Запрос отменен',
  ECONNABORTED: 'Запрос превысил время ожидания или был прерван',
  ETIMEDOUT: 'Истекло время ожидания запроса',
  ERR_EMAIL_EXIST: 'Электронная почта уже существует',
  E_INVALID_PARAM_DID: 'Неверный ID устройства',
  E_INVALID_DEVICEID: 'Неверный ID устройства',
  E_INVALID_ID: 'Неверный ID',
  E_GET_DEV_GROUP_DETAIL_ERR: 'Не удалось получить детальную информацию о устройстве',
  E_USER_NOT_FOUNT: 'Пользователь не существует',
  E_DEVICE_VNC_OFFLINE: ' VNC устройства недоступен',
  E_MISSING_AUTH_HEADER: 'Отсутствует заголовок TOKEN',
  E_TEMPLATE_CAN_NOT_DEL_WITH_BIND_DEV: 'Этот шаблон уже привязан к устройствам',
  E_INVALID_PASSWD: 'Неверный пароль',
  E_INPUT_PWD_ERR: ' Пароль введён неверно',
  E_INVALID_OR_EXPIRED_TOKEN: 'Сессия истекла. Войдите снова',
  E_USER_NOT_FOUND: 'Пользователь не существует',
  ERR_PHONE_NOT_VERIFY: 'Неверный код подтверждения',
  ERR_ACCOUNT_EXIST: 'Аккаунт уже существует',
  ERR_EMAIL_NOT_ACTIVE: 'Электронная почта не активирована',
  E_BILLING_TAG_RECORD_FOUND: 'Неверный номер карты или код доступа. Пожалуйста, проверьте данные',
  E_CLOUD_CARD_PWD_ERR: 'Неверный номер карты или код доступа. Пожалуйста, проверьте данные',
  E_BILLING_REMOTE_ACCESS_RECORD_FOUND: 'Неверный номер карты или код доступа. Пожалуйста, проверьте данные',
  E_CLOUD_CARD_ALREADY_ACTIVATE: 'Этот билет на оплату уже активирован. Повторная активация не допускается',
  E_SAFEAREAS_NAME_EXIST: 'Название безопасной зоны уже существует',
  E_SAFEAREAS_MORE_THAN_LIMIT: 'Можно добавить до 20 безопасных зон',
  E_hdd_team_group_name_exist: 'Группы в команде не могут дублироваться',
  E_MONITOR_TAG_NAME_EXIST: 'Названия мониторингов не могут повторяться',
  E_MONITOR_TAG_NUM_LIMIT: 'Количество тегов (TAG) превышает лимит.',
  E_DEV_OFFLINE: 'Это устройство офлайн',
  E_PARAM_NAME_INVALID: 'Неверные параметры. Проверьте данные.',
  E_PARAM_DESC_TOO_LONG: 'Описание слишком длинное',
  E_VALUE_OUT_OF_VALID_RANGE: 'Ввод вне диапазона',
  E_PLC_VALUE_RANGE_INVALID: 'Недопустимые данные адреса.',
  E_LINK_NAME_NOT_EXIST: 'Недопустимое имя ссылки.',

  '1003_1': 'Устройство отвязано. Пожалуйста, выберите его снова.',
  '1001': 'Ошибка аутентификации',
  '1002': 'Недостаточно прав доступа',
  '1003': 'Данные не найдены.',
  '1004': 'Неверный пароль',
  '1005': 'Ошибка базы данных',
  '1006': 'Ошибка входных параметров',
  '1007': 'Внутренняя ошибка сервера',
  '1008': 'Отсутствует Auth Header',
  '1009': 'Срок действия сессии истёк. Войдите снова',
  '1010': 'Пользователь не найден',
  '1011': 'Неверный код подтверждения',
  '1012': 'Пользователь уже существует',
  '1013': 'Не удалось отправить электронное письмо',
  '1014':
    'Чтобы активировать аккаунт, проверьте электронную почту, указанную при регистрации, и перейдите по ссылке в письме',
  '1015': 'Достигнут лимит отправки электронных писем',
  '1016': 'Номер телефона не подтверждён.',
  '1017': 'Запросите код подтверждения повторно',
  '1018': 'Не удалось отправить код подтверждения',
  '1019': 'Аккаунт не совпадает (аккаунт ресурса не совпадает)',
  '1020': 'Срок действия ссылки истёк. Запросите новую и завершите регистрацию.',
  '1021': 'Ошибка параметров',
  '1022': 'Код подтверждения истек',
  '1023': 'Сеанс не обнаружен. Отправьте RAND повторно для восстановления соединения',
  '1024': 'Пожалуйста, включите VNC на HMI',
  '1025': 'Некорректный Pin',
  '1026': 'Некорректная лицензия',
  '1027': 'Некорректный идентификатор группы устройств',
  '1028': 'Некорректный SN HMI',
  '1029': 'Некорректный идентификатор шаблона',
  '1030': 'Шаблон с таким названием уже существует',
  '1031': 'Ваш email не подтверждён',
  '1032': 'Нельзя удалить группу: в ней или подгруппах есть устройства',
  '1033': 'Достигнут максимальный лимит количества шаблонов',
  '1034': 'Название устройства уже существует',
  '1037': 'Этот шаблон связан с устройствами. Удаление невозможно',
  '1038': 'Устройство не в сети.',
  '1042': 'Нельзя переключиться на шаблон другого типа',
  '1043': 'Неверный номер карты или код доступа. Пожалуйста, проверьте данные',
  '1044': 'Срок активации абонемента истёк',
  '1045': 'Абонемент уже активирован. Повторная активация невозможна',
  '1050': 'Абонемент уже активирован. Повторная активация невозможна',
  '1055': 'Аккаунт удален',
  '1063': 'Имя роли уже существует',
  '1065': 'Максимально можно добавить 20 безопасных зон',
  '1066': 'Название безопасной зоны уже существует',
  '1069': 'Этот аккаунт уже состоит в другой команде',
  '1071': 'Этот аккаунт не входит в текущую команду',
  '1078': 'Аккаунт не принадлежит текущей базе данных.',
  '1085': 'Название группы оповещений уже существует',
  '1086': 'Название уже существует',
  '1087': 'Комбинированный проект с таким ID не найден в вашем аккаунте',
  '1088': 'Название оповещения уже существует',
  '1083': 'Группы в команде не могут дублироваться',
  '1090': 'Максимальное количество правил оповещений — 300',
  '1091': 'Устройство используется в конфигурации. Отвяжите его в DIAWebDesigner перед удалением',
  '1100': 'Превышено ограничение на количество тегов.',
  '2001': 'Не удалось загрузить Tar-пакета DIAView',
  '2003': 'Ошибка подключения',

  '1035': 'Превышен лимит запросов к историческим данным.',
  '1036': 'Слишком частые запросы. Подождите.',
  '1039': 'Некорректный SN Dongle',
  '1040': 'Refresh Token истек.',
  '1041': 'Обновите последние теги (TAG) с облака на устройство.',
  '1046': 'Нехватка трафика',
  '1047': 'Пользователь отказался от продолжения использования после достижения 12 ГБ трафика.',
  '1048': 'Пользователь подтвердил отказ от трафика после 12 ГБ. Использование прекращено до следующего месяца.',
  '1049': 'Неверный пароль',
  '1051': 'Срок активации истёк.',
  '1052': 'Шаблон заблокирован',
  '1053': 'В аккаунте есть устройства',
  '1054': 'В аккаунте есть шаблоны',
  '1056': 'Карта Remote Access уже привязана',
  '1057': 'Срок действия Remote Access истек',
  '1058': 'Нельзя выполнить операцию: обнаружены дочерние аккаунты.',
  '1059': 'Удаление субаккаунтов не поддерживается в DIACloud 1.0.',
  '1060': 'Обнаружены устройства в DIACloud 1.0.',
  '1062': 'Роль не принадлежит этому пользователю',
  '1064': 'Не удалось отправить приглашение по электронной почте',
  '1067': 'Безопасная зона используется. Удаление невозможно.',
  '1070': 'Не удалось отправить SMS-приглашение',
  '1072': 'Роль используется.',
  '1073': 'Отправитель приглашения покинул эту команду',
  '1074': 'Пользователь отменил приглашение',
  '1075': 'Пользователь не принял приглашение',
  '1076': 'Этот пользователь уже присоединился к команде',
  '1077': 'Администратор команды нельзя удалить.',
  '1079': 'Указанный шаблон не принадлежит вам.',
  '1080': 'Указанная группа не принадлежит вам.',
  '1081': 'Невозможно изменить доступ для администратора',
  '1082': 'Это приглашение недействительно',
  '1084': 'Этот пользователь уже присоединился к команде',
  '1089': 'Устройство не добавлено в комбинированный проект.',
  '1092': 'Обнаружены комбинированные проекты.',
  '1093': 'Некорректный адрес',
  '1094': 'Не удалось создать экземпляр DiaScreen lib',
  '1095': 'Не удалось получить список битов (bit)',
  '1096': 'Не удалось проверить диапазон адресов PLC',
  '1097': 'Не удалось получить список слов (word)',
  '1098': 'Не удалось получить список компонентов',
  '1099': 'Не удалось получить следующий адрес PLC',
  '1101': 'Не удалось получить учетные данные PLC по умолчанию',
  '1102': 'Текущий HMI SN уже был привязан',
  '1104': 'Аккаунт не найден в этой базе данных.',
  '1105': 'Субаккаунты не могут добавлять базу данных.',
  '1106': 'Этот аккаунт уже привязан к другой команде',
  '2002':
    'Ошибка settag: идентификатор шаблона на стороне устройства не синхронизирован. Ошибка settag: Идентификатор шаблон на устройстве не совпадает. Выполните синхронизацию.',
  '2011': 'Размер файла архива превышает лимит',
  '2012': 'Тип файла архива не поддерживается',
  '2013': 'Архив прошивки не существует',
  '2014': 'Архив прошивки не принадлежит текущей команде',
  '2015': 'Авторизация архива прошивки не существует',
  '2016': 'Пользователь уже авторизован, не повторяйте авторизацию',
  '2017': 'Достигнут лимит загрузок по авторизации архива прошивки',
  '2018': 'Статус задачи архива прошивки не позволяет отправку',
  '2019': 'Задача архива прошивки не соответствует параметрам отправки',
  '2020': 'Недопустимый ID архива прошивки',
  '2021': 'В этой команде уже существует архив прошивки с таким именем',
  E_ARCHIVE_FILE_TOO_LARGE: 'Размер файла архива превышает лимит',
  E_ARCHIVE_UNSUPPORTED_FILE_TYPE: 'Тип файла архива не поддерживается',
  E_ARCHIVE_FIRMWARE_NOT_FOUND: 'Архив прошивки не существует',
  E_ARCHIVE_FIRMWARE_NOT_IN_TEAM: 'Архив прошивки не принадлежит текущей команде',
  E_ARCHIVE_AUTH_NOT_FOUND: 'Авторизация архива прошивки не существует',
  E_ARCHIVE_AUTH_ALREADY_EXISTS: 'Пользователь уже авторизован, не повторяйте авторизацию',
  E_ARCHIVE_DOWNLOAD_LIMIT_REACHED: 'Достигнут лимит загрузок по авторизации архива прошивки',
  E_ARCHIVE_TASK_NOT_READY_FOR_REPORT: 'Статус задачи архива прошивки не позволяет отправку',
  E_ARCHIVE_TASK_NOT_MATCH: 'Задача архива прошивки не соответствует параметрам отправки',
  E_ARCHIVE_FIRMWARE_ID_INVALID: 'Недопустимый ID архива прошивки',
  E_ARCHIVE_FIRMWARE_NAME_EXISTS: 'В этой команде уже существует архив прошивки с таким именем',
  apiManage: {
    credentials: 'API ключи',
    logs: 'Журнал вызовов',
    statistics: 'Статистика вызовов',
    apiKey: 'API Key',
    applicationName: 'Имя приложения',
    status: 'Статус',
    permissions: 'Права API',
    dataScope: 'Область данных',
    validity: 'Срок действия',
    updatedBy: 'Обновил',
    updatedAt: 'Обновлено',
    lastUsedAt: 'Последний вызов',
    endpoint: 'Интерфейс',
    method: 'Метод',
    sourceIp: 'IP источника',
    statusCode: 'Код статуса',
    requestedAt: 'Время вызова',
    totalCalls: 'Всего вызовов',
    todayCalls: 'Сегодня',
    successCalls: 'Успешно',
    failedCalls: 'Ошибки',
    successRate: 'Успешность',
    all: 'Все',
    enabled: 'Включено',
    disabled: 'Отключено',
    expired: 'Истекло',
    createCredential: 'Создать API Key',
    editCredential: 'Изменить API Key',
    searchCredential: 'Поиск приложения / API Key',
    searchApplication: 'Поиск приложения',
    copyKey: 'Копировать API Key',
    copied: 'Скопировано',
    downloadDocument: 'Скачать документ API',
    resetSecret: 'Сбросить Secret',
    secretUnavailableAfterClose:
      'Скопируйте и надёжно сохраните API Key и Secret. После закрытия Secret нельзя будет посмотреть снова.',
    copyAndClose: 'Копировать и закрыть',
    resetSecretTip: 'Старый Secret станет недействительным. Подтвердите обновление вызывающей системы.',
    confirmEnable: 'Включить API Key',
    confirmDisable: 'Отключить API Key',
    statusChangeTip: 'Статус вызовов {0} изменится. Продолжить?',
    expiredCredentialTip: 'API Key истёк. Сначала продлите срок действия.',
    deleteCredentialTip: '{0} больше не сможет вызывать API после удаления.',
    applicationNamePlaceholder: 'Введите имя приложения',
    selectPermissions: 'Выберите права API',
    completeRequiredFields: 'Заполните обязательные поля',
    selectScopeValues: 'Настройте область данных',
    scopePermissionDenied: 'Недостаточно прав',
    ipWhitelist: 'Белый список IP',
    ipWhitelistPlaceholder: 'Один IP в строке; оставьте пустым без ограничений',
    ipWhitelistInvalid: 'Неверный формат белого списка IP',
    allData: 'Все данные',
    specifiedDevice: 'Указанные устройства',
    specifiedGroup: 'Указанные группы',
    specifiedTemplate: 'Указанные шаблоны',
    validityDays: '{0} дней',
    productionEnvironment: 'Рабочая среда клиента',
    thirdPartyDashboard: 'Тест сторонней панели',
    defaultOperator: 'Системный администратор',
    documentTitle: 'Документ DIACloud Open API',
    generatedAt: 'Время создания',
    deviceRead: 'Данные устройств',
    telemetryRead: 'Телеметрия в реальном времени',
    telemetryWrite: 'Операции телеметрии',
    historyRead: 'Исторические данные',
    alarmRead: 'Запрос тревог',
    alarmWrite: 'Обратная запись тревог',
    deviceReadDescription: 'Основные данные устройств',
    telemetryReadDescription: 'Телеметрия в реальном времени',
    telemetryWriteDescription: 'Запись и управление телеметрией',
    historyReadDescription: 'Запрос исторических данных',
    alarmReadDescription: 'Запрос тревог',
    alarmWriteDescription: 'Обратная запись тревог',
    defaultGroup: 'Группа по умолчанию',
    productionLine: 'Производственная линия',
    productionTemplate: 'Шаблон производства',
    energyTemplate: 'Шаблон энергии',
  },
  firmware: {
    firmware: 'Архив',
    plcName: 'Название архива',
    version: 'Версия',
    fileName: 'Имя файла',
    fileSize: 'Размер файла',
    md5: 'MD5',
    type: 'Тип',
    uploadTime: 'Время создания',
    operator: 'Создатель',
    authorizer: 'Оператор',
    uploadFirmware: 'Загрузить архив',
    uploadTip: 'Нажмите или перетащите файлы архива, можно несколько',
    uploadFormat: 'Поддерживаемый формат',
    fileTypeError: 'Разрешены только файлы .isp, .dvp, .diaobj или .inivals',
    fileSizeLimit: 'Суммарный размер файлов не должен превышать 50 МБ',
    pleaseSelectFile: 'Выберите файл',
    pleaseInputPlcName: 'Введите название архива',
    pleaseInputVersion: 'Введите версию',
    plcNamePlaceholder: 'Введите название архива',
    versionPlaceholder: 'Введите версию',
    uploadSuccess: 'Загрузка успешна',
    uploadFailed: 'Не удалось загрузить файл',
    authorize: 'Авторизовать',
    authorizeFirmware: 'Авторизация архива',
    firmwareName: 'Название архива',
    selectAccount: 'Выберите аккаунт',
    downloadLimit: 'Количество загрузок',
    downloadLimitPlaceholder: 'Введите количество загрузок',
    isAuthorized: 'Авторизован',
    filterAuthorized: 'Фильтр по авторизации',
    authorizedAccount: 'Авторизованный аккаунт',
    authorizeTime: 'Время операции',
    authorizeInfo: 'Информация об авторизации',
    authorizeDetail: 'Детали авторизации',
    downloadCount: 'Количество авторизаций',
    pleaseSelectAccount: 'Выберите аккаунт',
    pleaseInputDownloadLimit: 'Введите количество авторизаций',
    authorizeSuccess: 'Авторизация успешна',
    downloadLimitReached: 'Достигнут лимит загрузок',
    downloadStart: 'Загрузка...',
    downloadSuccess: 'Загрузка завершена',
    deleteConfirm: 'Удалить этот архив?',
    deleteSuccess: 'Удаление успешно',
    authorizeGuide: 'Архив загружен. Авторизовать его сейчас?',
    goAuthorize: 'Авторизовать',
    skipAuthorize: 'Не сейчас',
    accountsAuthorized: 'аккаунтов авторизовано',
    authorizeRecords: 'Записи авторизации',
    noAuthRecords: 'Нет записей авторизации',
    deleteFirmware: 'Подтвердить удаление архива',
    userAccount: 'Аккаунт',
    pleaseInputAccount: 'Введите аккаунт',
    accountPlaceholder: 'Введите аккаунт, несколько через запятую',
    plcNameSearch: 'Поиск названия архива',
    dispatchRecords: 'Записи загрузки',
    hmiDispatchCountTip: 'Каждая успешная отправка программы HMI на ПЛК считается один раз',
    noDispatchRecords: 'Нет записей загрузки',
    archiveType: 'Тип архива',
    pleaseSelectArchiveType: 'Выберите тип архива',
    deviceId: 'ID устройства',
    deviceName: 'Имя устройства',
    limitCount: 'Ограничить количество',
    noLimit: 'Без ограничения',
    hmiDispatchTip: 'HMI успешно отправил программу в ПЛК',
  },
  sim: {
    simInfo: 'Информация о SIM-карте',
    inUse: 'Используется',
    rechargeRecord: 'История пополнений',
    packageName: 'Название пакета',
    effectiveTime: 'Дата активации',
    expireTime: 'Дата истечения',
    monthUsedTraffic: 'Трафик за месяц',
    monthRemainTraffic: 'Остаток трафика за месяц',
    packageUpgrade: 'Обновить пакет',
    packageRenew: 'Продлить пакет',
  },
}
